export const patients = [
  ['Abelar, Jayne', 'abgermancar@gmail.com', '(415) 555-1021', 'Active'],
  ['Abreham, Elsa', 'elsaab3145@gmail.com', '(212) 555-3045', 'Inactive'],
  ['Ackerson, Jennifer', 'Jackson1@hotmail.com', '(310) 555-6789', 'Active'],
  ['Ackerson, David', 'david.ackerson@me.com', '(617) 555-8912', 'Active'],
  ['Adam, Ortner', 'adamortner@me.com', '(408) 555-1456', 'Active'],
  ['Adolphsen, Steve', 'stevesmusic22@yahoo.com', '(305) 555-2234', 'Active'],
  ['Adrianna, Havey', 'ahavey17@gmail.com', '(512) 555-7810', 'Active'],
  ['Aguilar, Francisco', 'kikow3131@yahoo.com', '(702) 555-9321', 'Inactive'],
  ['Alamares, Serena', 'serenablier13@yahoo.com', '(646) 555-4578', 'Inactive'],
  ['Alden, Dawn', 'dalden2018@gmail.com', '(206) 555-8145', 'Active']
].map((item, index) => ({
  id: index + 1,
  patient: item[0],
  email: item[1],
  mobile: item[2],
  status: item[3]
}));

export const users = [
  ['Chen, James', 'james.chen@example.com', true, false, false, 'Active'],
  ['Ketcham, Judy', 'judy.ketcham@example.com', false, true, true, 'Inactive'],
  ['Laigo, Severin', 'severin.laigo@example.com', true, false, false, 'Active'],
  ['Lomeli, Maria', 'maria.lomeli@example.com', false, true, false, 'Active'],
  ['Macabenta, Sheryl', 'sheryl.macabenta@example.com', false, true, false, 'Active'],
  ['Morales, Melissa', 'melissa.morales@example.com', true, false, true, 'Active'],
  ['Low, Henry', 'henry.low@example.com', false, true, false, 'Active'],
  ['De Torre, Maria', 'maria.detorre@example.com', false, true, false, 'Inactive'],
  ['Alamares, Serena', 'serena.alamares@example.com', false, true, true, 'Inactive'],
  ['Severin, Liwag', 'liwag.severin@example.com', true, false, false, 'Active']
].map((item, index) => ({
  id: index + 1,
  name: item[0],
  email: item[1],
  provider: item[2],
  staff: item[3],
  admin: item[4],
  status: item[5]
}));